import { useAppDispatch, useAppSelector, useAppStore } from "@/app/appStore";
import {
  selectGondolaDropdownValue,
  selectSelectedGondola,
  setCurrentCamera,
  setGondolaByName,
  setGondolaDropdownValue,
  setGondolaDropdownValueByName,
  setSelectedGondola,
  CameraMode,
  setSelectedCameraMode,
} from "@/entities/annotation";
import { allOption } from "../ui/gondola-select";
import { useCameras } from "./useCameras";
import { CAMERA_MODES } from "@/entities/annotation/model/consts";
import { usePlayer } from "@tezzro/player";

const useCameraHandlers = () => {
  const dispatch = useAppDispatch();
  const store = useAppStore();
  const player = usePlayer();
  const cameraData = useCameras();
  const gondolaDropdownValue = useAppSelector(selectGondolaDropdownValue);
  const selectedGondola = useAppSelector(selectSelectedGondola);

  const handleDefaultCameraSelect = (cameraId: string) => {
    const gondolaName = cameraData?.findCameraGondolaName?.(cameraId);

    dispatch(setGondolaByName(gondolaName || null));
    dispatch(setGondolaDropdownValue(allOption));
    player.changeCamera(cameraId);
    dispatch(setCurrentCamera(cameraId));
    cameraData.setCameraModeFromCameraId(cameraId);
  };

  const handleCameraSelect = (cameraId: string) => {
    if (gondolaDropdownValue?.name.toLowerCase() === CAMERA_MODES.ALL) {
      const gondolaName = cameraData?.findCameraGondolaName?.(cameraId);
      gondolaName
        ? dispatch(setGondolaByName(gondolaName))
        : dispatch(setSelectedGondola(null));
    }

    dispatch(setCurrentCamera(cameraId));
    cameraData.setCameraModeFromCameraId(cameraId);
    player.changeCamera(cameraId);
  };

  const handleMapCameraSelect = (cameraId: string) => {
    const gondolaName = cameraData?.findCameraGondolaName?.(cameraId);

    if (gondolaName) {
      dispatch(setGondolaByName(gondolaName));
      dispatch(setGondolaDropdownValueByName(gondolaName));
    } else {
      dispatch(setSelectedGondola(null));
      dispatch(setGondolaDropdownValue(allOption));
    }

    dispatch(setCurrentCamera(cameraId));
    dispatch(setSelectedCameraMode(cameraData.findCameraMode(cameraId)));
    player.changeCamera(cameraId);
  };

  const handleCameraModeSelect = (cameraMode: CameraMode) => {
    dispatch(setSelectedCameraMode(cameraMode));
    const currentCameraMode = cameraData?.findCameraMode(
      store.getState().annotation.currentCamera
    );
    let nextCameraID;

    switch (cameraMode) {
      case CAMERA_MODES.HAND:
        if (currentCameraMode !== CAMERA_MODES.HAND) {
          nextCameraID = selectedGondola?.handTrackingCameras?.[0]?.id;
        }
        break;
      case CAMERA_MODES.SHELF:
        if (currentCameraMode !== CAMERA_MODES.SHELF) {
          nextCameraID = selectedGondola?.shelfTrackingCameras?.[0]?.id;
        }
        break;
    }

    if (nextCameraID) {
      dispatch(setCurrentCamera(nextCameraID));
      player.changeCamera(nextCameraID);
    }
  };

  return {
    handleDefaultCameraSelect,
    handleCameraSelect,
    handleMapCameraSelect,
    handleCameraModeSelect,
    cameraData,
  };
};

export default useCameraHandlers;
